import React, { Component, Fragment } from "react";
import IndexBlock from "../IndexBlockTitle";
import Block, { ScrollableBlock } from "../Block";
import PropTypes from "prop-types";

import "./style.css";
const componentRef = React.createRef();
class IndexBox extends Component {
  focus() {
    componentRef.current.scrollIntoView({
      block: "end",
      behavior: "smooth"
    });
  }

  render() {
    const {
      children,
      className,
      subtitle,
      index,
      title,
      onClick,
      onMoveAbove,
      onMoveBelow
    } = this.props;

    return (
      <Fragment>
        <ScrollableBlock
          onClick={onClick}
          className={`index-block ${!!onClick ? "pointer" : ""} ${className}`}
          ref={componentRef}
        >
          <IndexBlock index={index} title={title} onMoveAbove={onMoveAbove} onMoveBelow={onMoveBelow} />
        </ScrollableBlock>
        <Block className="isoBoxWrapper indexBox indexBoxWrapper">
          <IndexBlock subtitle={subtitle} />
          {children}
        </Block>
      </Fragment>
    );
  }
}

IndexBox.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  index: PropTypes.string,
  title: PropTypes.string
};

export default IndexBox;



// WEBPACK FOOTER //
// ./src/components/ui-ant/IndexBox/index.js